<ng-template #historyTemplate let-row let-column="column">
  <div
    class="c-rate-history"
    [class.c-rate-history--active]="row.isActive !== false"
    [class.c-rate-history--historical]="row.isActive === false"
  >
    <p
      class="u-text u-fw-bold c-rate-history__status"
      [style.--text-color]="
        row.isActive !== false
          ? 'var(--color-context-success)'
          : 'var(--color-neutral-600)'
      "
    >
      @if (row.isActive !== false) {
        {{ 'rates.active' | translate }}
      } @else {
        {{ 'rates.historical' | translate }}
      }
      @if (row.version !== undefined && row.version !== null) {
        <span class="u-text--xs"> · v{{ row.version }}</span>
      }
    </p>
    @if (row.isActive === false) {
      <p
        class="u-text--xs c-rate-history__meta"
        [style.--text-color]="'var(--color-neutral-600)'"
      >
        {{ 'rates.disabledAt' | translate }}: {{ formatDisabledAt(row.disabledAt) }}
      </p>
    }
  </div>
</ng-template>

<core-generic-table
    #ratesTable
    [endpoint]="endpoint()"
    [customParams]="customParams()"
    [listTitle]="'rates.title' | translate"
    [columns]="columns"
    [modalTabs]="modalFieldsTabs()"
    [actions]="actions"
    [globalActions]="globalCustomActions()"
    [modelFactory]="ratesModelFactory"
    [showFilter]="false"
    [showSelection]="false"
    [showActions]="true"
    [showCreateButton]="true"
    [enablePagination]="true"
    [moreData]="moreData()"
    [sortConfig]="sortConfig()"
    [rowStyleConfigs]="rowStyleConfigs()"
    (onMoreDataLoaded)="onMoreDataLoaded($event)"
    (dataCreated)="refreshRatesTable()"
    (dataUpdated)="refreshRatesTable()"
    [onApiError]="handleApiError"
    [createButtonConfig]="createButtonConfig()">
</core-generic-table>
